import React, { useState, useRef } from "react";
import { Button, Container } from "react-bootstrap";
import { MdCheck, MdContentCopy } from "react-icons/md";
function Contact() {
  // Refs
  const copybtn = useRef(null);

  // states
  const [op, setop] = useState("0");
  const [hd, sethd] = useState("hidden");
  const [email, setEmail] = useState("zerko.gg");
  const [copytext, setcopy] = useState(false);
  // functions
  const copyAction = () => {
    navigator.clipboard.writeText(email);
    setcopy(true);
  }; //Copynig action + state change

  const emailLoad = (email) => {
    setop("0");
    setTimeout(() => {
      setEmail(email);
      setcopy(false);
      sethd("visible");
    }, 300);
    setTimeout(() => {
      setop("1");
    }, 350);
  }; //transition for each click
  return (
    <>
      <Container fluid className=" bg-brand pt-10vh pb-3">
        <h1
          data-aos="fade-up"
          className="display-4  fw-bold text-center text-white px-0 px-md-5 mb-5"
        >
          Contact The Zerko Team
        </h1>
        <Container
          data-aos="fade-up"
          className="d-flex flex-column flex-md-row justify-content-center gap-3 gap-md-5"
        >
          <Button
            variant="dark"
            className="p-3 btn-lg my-2 contact_btn"
            onClick={() => emailLoad("recruit@zerko.gg")}
          >
            Become A Creator
          </Button>
          <Button
            variant="dark"
            className="p-3 btn-lg my-2 contact_btn"
            onClick={() => emailLoad("sponsorship@zerko.gg")}
          >
            Become A Sponsor
          </Button>
          <Button
            variant="dark"
            className="p-3 btn-lg my-2 contact_btn"
            onClick={() => emailLoad("info@zerko.gg")}
          >
            General Questions
          </Button>
        </Container>

        <Container>
          <div
            className="d-flex flex-column flex-md-row justify-content-center align-items-center py-5 rounded-3 text-white basket"
            style={{ opacity: op, visibility: hd }}
          >
            <h5 className="display-5 fs-2 mx-2">{email}</h5>
            {copytext && copytext ? (
              <Button variant="primary" active onClick={() => copyAction()}>
                <MdCheck /> <span className="fs-6"> copied</span>
              </Button>
            ) : (
              <Button ref={copybtn} variant="dark" onClick={() => copyAction()}>
                <MdContentCopy /> <span className="fs-6"> copy</span>
              </Button>
            )}
          </div>
        </Container>
      </Container>
    </>
  );
}
export default React.memo(Contact);
